angular.module('Const').constant('TableTemplateUrls', {
    filters: {
        'button': '/templates/directives/intellectual-table/filters-cells/buttons.html',
        'datePicker': '/templates/directives/intellectual-table/filters-cells/datePicker.html',
        'text': '/templates/directives/intellectual-table/filters-cells/text.html',
        'inputDropdown': '/templates/directives/intellectual-table/filters-cells/inputDropdown.html',
        'select2': '/templates/directives/intellectual-table/filters-cells/select2.html',
        'autoComplete': '/templates/directives/intellectual-table/filters-cells/autocomplete.html',
        'checkbox': '/templates/directives/intellectual-table/filters-cells/checkbox.html',
        'multipleSelect': '/templates/directives/intellectual-table/filters-cells/multiple.html',
        'chipText': '/templates/directives/intellectual-table/filters-cells/bba-input-chips.html'
    },
    body: {
        'logotype': '/templates/directives/intellectual-table/body-cells/logotype.html',
        'multiLine': '/templates/directives/intellectual-table/body-cells/multiLine.html',
        'status': '/templates/directives/intellectual-table/body-cells/status.html',
        'select2-multiple': '/templates/directives/intellectual-table/body-cells/select2-multiple.html',
        'waypoints': '/templates/directives/intellectual-table/body-cells/waypoints.html',
        'summary': '/templates/directives/intellectual-table/body-cells/summary.html'
    },
    actionBody: {
        'link': '/templates/directives/intellectual-table/body-cells/link.html',
        'multipleLink':'/templates/directives/intellectual-table/body-cells/array-links.html',
        'radio': '/templates/directives/intellectual-table/body-cells/radio.html',
        'switch': '/templates/directives/intellectual-table/body-cells/switcher.html',
        'button': '/templates/directives/intellectual-table/body-cells/buttons.html',
        'checkbox': '/templates/directives/intellectual-table/body-cells/checkbox.html',
        'textInput': '/templates/directives/intellectual-table/body-cells/textInput.html',
        'numberInput': '/templates/directives/intellectual-table/body-cells/numberInput.html',
        'select2': '/templates/directives/intellectual-table/body-cells/select2.html'
    }

});


// WEBPACK FOOTER //
// ./js/consts/TableTemplateUrls.js